module.exports = {
  buildVersion: "4.0.0",
  buildDate: 1778451743874,
}